function FlagIcons() {
  return (
    <div>
      <div className="page-header">
        <h3 className="page-title">Flag icons</h3>
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <a href="!#" onClick={(event) => event.preventDefault()}>
                Icons
              </a>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              Flag icons
            </li>
          </ol>
        </nav>
      </div>
      <div className="row">
        <div className="col-lg-12 grid-margin">
          <div className="card">
            <div className="card-body">
              <h4 className="card-title">Flag icons</h4>
              <div className="icons-list row">
                <div className="col-6 col-md-3">
                  <i className="fi fi-ad" title="ad" id="ad"></i> AD
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-ae" title="ae" id="ae"></i> AE
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-af" title="af" id="af"></i> AF
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-ag" title="ag" id="ag"></i> AG
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-ai" title="ai" id="ai"></i> AU
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-al" title="al" id="al"></i> AL
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-am" title="am" id="am"></i> AM
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-ao" title="ao" id="ao"></i> AO
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-aq" title="aq" id="aq"></i> AQ
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-ar" title="ar" id="ar"></i> AR
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-as" title="as" id="as"></i> AS
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-at" title="at" id="at"></i> AT
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-au" title="au" id="au"></i> AU
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-aw" title="aw" id="aw"></i> AW
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-ax" title="ax" id="ax"></i> AX
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-az" title="az" id="az"></i> AZ
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-ba" title="ba" id="ba"></i> BA
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-bb" title="bb" id="bb"></i> BB
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-bd" title="bd" id="bd"></i> BD
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-be" title="be" id="be"></i> BE
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-bf" title="bf" id="bf"></i> BF
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-bg" title="bg" id="bg"></i> BG
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-bh" title="bh" id="bh"></i> BH
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-bi" title="bi" id="bi"></i> BI
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-bj" title="bj" id="bj"></i> BJ
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-bl" title="bl" id="bl"></i> BL
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-bm" title="bm" id="bm"></i> BM
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-bn" title="bn" id="bn"></i> BN
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-bo" title="bo" id="bo"></i> BO
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-bq" title="bq" id="bq"></i> BQ
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-br" title="br" id="br"></i> BR
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-bs" title="bs" id="bs"></i> BS
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-bt" title="bt" id="bt"></i> BT
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-bv" title="bv" id="bv"></i> BV
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-bw" title="bw" id="bw"></i> BW
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-by" title="by" id="by"></i> BY
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-bz" title="bz" id="bz"></i> BZ
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-ca" title="ca" id="ca"></i> CA
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-cc" title="cc" id="cc"></i> CC
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-cd" title="cd" id="cd"></i> CD
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-cf" title="cf" id="cf"></i> CF
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-cg" title="cg" id="cg"></i> CG
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-ch" title="ch" id="ch"></i> CH
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-ci" title="ci" id="ci"></i> CI
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-ck" title="ck" id="ck"></i> CK
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-cl" title="cl" id="cl"></i> CL
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-cm" title="cm" id="cm"></i> CM
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-cn" title="cn" id="cn"></i> CN
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-co" title="co" id="co"></i> CO
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-cr" title="cr" id="cr"></i> CR
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-cu" title="cu" id="cu"></i> CU
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-cv" title="cv" id="cv"></i> CV
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-cw" title="cw" id="cw"></i> CW
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-cx" title="cx" id="cx"></i> CX
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-cy" title="cy" id="cy"></i> CY
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-cz" title="cz" id="cz"></i> CZ
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-de" title="de" id="de"></i> DE
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-dj" title="dj" id="dj"></i> DJ
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-dk" title="dk" id="dk"></i> DK
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-dm" title="dm" id="dm"></i> DM
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-do" title="do" id="do"></i> DO
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-dz" title="dz" id="dz"></i> DZ
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-ec" title="ec" id="ec"></i> EC
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-ee" title="ee" id="ee"></i> EE
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-eg" title="eg" id="eg"></i> EG
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-eh" title="eh" id="eh"></i> EH
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-er" title="er" id="er"></i> ER
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-es" title="es" id="es"></i> ES
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-et" title="et" id="et"></i> ET
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-fi" title="fi" id="fi"></i> FI
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-fj" title="fj" id="fj"></i> FJ
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-fk" title="fk" id="fk"></i> FK
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-fm" title="fm" id="fm"></i> FM
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-fo" title="fo" id="fo"></i> FO
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-fr" title="fr" id="fr"></i> FR
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-ga" title="ga" id="ga"></i> GA
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-gb" title="gb" id="gb"></i> GB
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-gd" title="gd" id="gd"></i> GD
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-ge" title="ge" id="ge"></i> GE
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-gf" title="gf" id="gf"></i> GF
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-gg" title="gg" id="gg"></i> GG
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-gh" title="gh" id="gh"></i> GH
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-gi" title="gi" id="gi"></i> GI
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-gl" title="gl" id="gl"></i> GL
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-gm" title="gm" id="gm"></i> GM
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-gn" title="gn" id="gn"></i> GN
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-gp" title="gp" id="gp"></i> GP
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-gq" title="gq" id="gq"></i> GQ
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-gr" title="gr" id="gr"></i> GR
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-gs" title="gs" id="gs"></i> GS
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-gt" title="gt" id="gt"></i> GT
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-gu" title="gu" id="gu"></i> GU
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-gw" title="gw" id="gw"></i> GW
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-gy" title="gy" id="gy"></i> GY
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-hk" title="hk" id="hk"></i> HK
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-hm" title="hm" id="hm"></i> HM
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-hn" title="hn" id="hn"></i> HN
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-hr" title="hr" id="hr"></i> HR
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-ht" title="ht" id="ht"></i> HT
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-hu" title="hu" id="hu"></i> HU
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-id" title="id" id="id"></i> ID
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-ie" title="ie" id="ie"></i> IE
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-il" title="il" id="il"></i> IL
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-im" title="im" id="im"></i> IM
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-in" title="in" id="in"></i> IN
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-io" title="io" id="io"></i> IO
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-iq" title="iq" id="iq"></i> IQ
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-ir" title="ir" id="ir"></i> IR
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-is" title="is" id="is"></i> IS
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-it" title="it" id="it"></i> IT
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-je" title="je" id="je"></i> JE
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-jm" title="jm" id="jm"></i> JM
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-jo" title="jo" id="jo"></i> JO
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-jp" title="jp" id="jp"></i> JP
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-ke" title="ke" id="ke"></i> KE
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-kg" title="kg" id="kg"></i> KG
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-kh" title="kh" id="kh"></i> KH
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-ki" title="ki" id="ki"></i> KI
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-km" title="km" id="km"></i> KM
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-kn" title="kn" id="kn"></i> KN
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-kp" title="kp" id="kp"></i> KP
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-kr" title="kr" id="kr"></i> KR
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-kw" title="kw" id="kw"></i> KW
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-ky" title="ky" id="ky"></i> KY
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-kz" title="kz" id="kz"></i> KZ
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-la" title="la" id="la"></i> LA
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-lb" title="lb" id="lb"></i> LB
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-lc" title="lc" id="lc"></i> LC
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-li" title="li" id="li"></i> LI
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-lk" title="lk" id="lk"></i> LK
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-lr" title="lr" id="lr"></i> LR
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-ls" title="ls" id="ls"></i> LS
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-lt" title="lt" id="lt"></i> LT
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-lu" title="lu" id="lu"></i> LU
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-lv" title="lv" id="lv"></i> LV
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-ly" title="ly" id="ly"></i> LY
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-ma" title="ma" id="ma"></i> MA
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-mc" title="mc" id="mc"></i> MC
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-md" title="md" id="md"></i> MD
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-me" title="me" id="me"></i> ME
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-mf" title="mf" id="mf"></i> MF
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-mg" title="mg" id="mg"></i> MG
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-mh" title="mh" id="mh"></i> MH
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-mk" title="mk" id="mk"></i> MK
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-ml" title="ml" id="ml"></i> ML
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-mm" title="mm" id="mm"></i> MM
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-mn" title="mn" id="mn"></i> MN
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-mo" title="mo" id="mo"></i> MO
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-mp" title="mp" id="mp"></i> MP
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-mq" title="mq" id="mq"></i> MQ
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-mr" title="mr" id="mr"></i> MR
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-ms" title="ms" id="ms"></i> MS
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-mt" title="mt" id="mt"></i> MT
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-mu" title="mu" id="mu"></i> MU
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-mv" title="mv" id="mv"></i> MV
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-mw" title="mw" id="mw"></i> MW
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-mx" title="mx" id="mx"></i> MX
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-my" title="my" id="my"></i> MY
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-mz" title="mz" id="mz"></i> MZ
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-na" title="na" id="na"></i> NA
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-nc" title="nc" id="nc"></i> NC
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-ne" title="ne" id="ne"></i> NE
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-nf" title="nf" id="nf"></i> NF
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-ng" title="ng" id="ng"></i> NG
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-ni" title="ni" id="ni"></i> NI
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-nl" title="nl" id="nl"></i> NL
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-no" title="no" id="no"></i> NO
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-np" title="np" id="np"></i> NP
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-nr" title="nr" id="nr"></i> NR
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-nu" title="nu" id="nu"></i> NU
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-nz" title="nz" id="nz"></i> NZ
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-om" title="om" id="om"></i> OM
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-pa" title="pa" id="pa"></i> PA
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-pe" title="pe" id="pe"></i> PE
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-pf" title="pf" id="pf"></i> PF
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-pg" title="pg" id="pg"></i> PG
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-ph" title="ph" id="ph"></i> PH
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-pk" title="pk" id="pk"></i> PK
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-pl" title="pl" id="pl"></i> PL
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-pm" title="pm" id="pm"></i> PM
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-pn" title="pn" id="pn"></i> PN
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-pr" title="pr" id="pr"></i> PR
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-ps" title="ps" id="ps"></i> PS
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-pt" title="pt" id="pt"></i> PT
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-pw" title="pw" id="pw"></i> PW
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-py" title="py" id="py"></i> PY
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-qa" title="qa" id="qa"></i> QA
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-re" title="re" id="re"></i> RE
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-ro" title="ro" id="ro"></i> RO
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-rs" title="rs" id="rs"></i> RS
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-ru" title="ru" id="ru"></i> RU
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-rw" title="rw" id="rw"></i> RW
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-sa" title="sa" id="sa"></i> SA
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-sb" title="sb" id="sb"></i> SB
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-sc" title="sc" id="sc"></i> SC
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-sd" title="sd" id="sd"></i> SD
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-se" title="se" id="se"></i> SE
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-sg" title="sg" id="sg"></i> SG
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-sh" title="sh" id="sh"></i> SH
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-si" title="si" id="si"></i> SI
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-sj" title="sj" id="sj"></i> SJ
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-sk" title="sk" id="sk"></i> SK
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-sl" title="sl" id="sl"></i> SL
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-sm" title="sm" id="sm"></i> SM
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-sn" title="sn" id="sn"></i> SN
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-so" title="so" id="so"></i> SO
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-sr" title="sr" id="sr"></i> SR
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-ss" title="ss" id="ss"></i> SS
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-st" title="st" id="st"></i> ST
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-sv" title="sv" id="sv"></i> SV
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-sx" title="sx" id="sx"></i> SX
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-sy" title="sy" id="sy"></i> SY
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-sz" title="sz" id="sz"></i> SZ
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-tc" title="tc" id="tc"></i> TC
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-td" title="td" id="td"></i> TD
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-tf" title="tf" id="tf"></i> TF
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-tg" title="tg" id="tg"></i> TG
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-th" title="th" id="th"></i> TH
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-tj" title="tj" id="tj"></i> TJ
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-tk" title="tk" id="tk"></i> TK
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-tl" title="tl" id="tl"></i> TL
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-tm" title="tm" id="tm"></i> TM
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-tn" title="tn" id="tn"></i> TN
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-to" title="to" id="to"></i> TO
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-tr" title="tr" id="tr"></i> TR
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-tt" title="tt" id="tt"></i> TT
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-tv" title="tv" id="tv"></i> TV
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-tw" title="tw" id="tw"></i> TW
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-tz" title="tz" id="tz"></i> TZ
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-ua" title="ua" id="ua"></i> UA
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-ug" title="ug" id="ug"></i> UG
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-um" title="um" id="um"></i> UM
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-us" title="us" id="us"></i> US
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-uy" title="uy" id="uy"></i> UY
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-uz" title="uz" id="uz"></i> UZ
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-va" title="va" id="va"></i> VA
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-vc" title="vc" id="vc"></i> VC
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-ve" title="ve" id="ve"></i> VE
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-vg" title="vg" id="vg"></i> VG
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-vi" title="vi" id="vi"></i> VI
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-vn" title="vn" id="vn"></i> VN
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-vu" title="vu" id="vu"></i> VU
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-wf" title="wf" id="wf"></i> WF
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-ws" title="ws" id="ws"></i> WS
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-ye" title="ye" id="ye"></i> YE
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-yt" title="yt" id="yt"></i> YT
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-za" title="za" id="za"></i> ZA
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-zm" title="zm" id="zm"></i> ZM
                </div>
                <div className="col-6 col-md-3">
                  <i className="fi fi-zw" title="zw" id="zw"></i> ZW
                </div>
                <div className="col-6 col-md-3">
                </div>
                <div className="col-6 col-md-3">
                </div>
                <div className="col-6 col-md-3">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default FlagIcons;
